import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { isValidFunction, tr, useFormValues } from 'mmfintech-commons'

import { Link } from 'react-router-dom'
import { Button, ErrorDisplay, Input } from 'mmfintech-portal-commons'

import type { CreditCardConfirmStepProps } from '../types'

export const CreditCardPin = ({ onSubmit, onCancel }: CreditCardConfirmStepProps) => {
  const { checkoutPayError, checkoutPayFetching } = useSelector(
    ({ checkout: { checkoutPayError, checkoutPayFetching } }) => ({
      checkoutPayError,
      checkoutPayFetching
    }),
    shallowEqual
  )

  const formValues = useFormValues({
    pin: { required: true }
  })

  const handleSubmit = () => {
    if (formValues.areValid()) {
      onSubmit(formValues.prepare())
    }
  }

  useEffect(() => {
    return () => {
      formValues.reset()
    }
  }, [])

  return (
    <>
      <div className='payment-method-wrapper' data-test='credit-card-pin'>
        {tr('CHECKOUT.CREDIT_CARD.PIN.TITLE', 'Confirm payment')}
      </div>

      <Input
        type='text'
        data-test='pin-input'
        label={tr('CHECKOUT.CREDIT_CARD.PIN.PIN', 'PIN')}
        {...formValues.registerInput('pin')}
        hideErrorLine
        autoComplete='off'
      />

      <ErrorDisplay error={checkoutPayError} />

      <div className='buttons'>
        <Button
          type='button'
          color='primary'
          text={tr('CHECKOUT.CREDIT_CARD.COMPLETE_BUTTON', 'Complete payment')}
          onClick={handleSubmit}
          loading={checkoutPayFetching}
          data-test='button-complete'
        />
        {isValidFunction(onCancel) && (
          <div className='cancel-button-container mt-1'>
            <Link to='#' onClick={onCancel} data-test='cancel-button'>
              {tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            </Link>
          </div>
        )}
      </div>
    </>
  )
}
